/* eslint-disable no-constant-condition */
import React from "react";

import * as Styles from "./historicoBody.styles";

interface ValoresInterface {
  campoAlterado: string;
  valorAntigo: string;
  valorNovo: string;
}

interface Props {
  valores: ValoresInterface[];
}

const HistoricoOportunidade: React.FC<Props> = ({ valores }) => {
  return (
    <>
      <Styles.BodyTarefas>
        {valores?.map((item: ValoresInterface) => (
          <>
            {item.campoAlterado === "Numero cotação" ? (
              <>
                <Styles.Text style={{ marginRight: 4 }}>
                  Nova oportunidade:{" "}
                  <Styles.Text style={{ color: "#2E5BFF" }}>
                    {item.valorNovo}
                  </Styles.Text>
                </Styles.Text>
              </>
            ) : (
              <></>
            )}
            {item.campoAlterado === "Nome Empreendimento" ? (
              <>
                <Styles.Text style={{ marginRight: 4 }}>
                  Produto: {item.valorNovo}
                </Styles.Text>
              </>
            ) : (
              <></>
            )}
            {item.campoAlterado === "Unidade" ? (
              <Styles.Text style={{ marginRight: 4, width: "50%" }}>
                {item.campoAlterado}: {item.valorNovo}
              </Styles.Text>
            ) : (
              <></>
            )}
            {item.campoAlterado === "Bloco" ? (
              <Styles.Text style={{ marginRight: 4, width: "50%" }}>
                {item.campoAlterado}: {item.valorNovo}
              </Styles.Text>
            ) : (
              <></>
            )}

            {item.campoAlterado === "Etapa Oportunidade" ? (
              <>
                <Styles.TagAlteracaoBody>
                  <Styles.Text style={{ margin: "0 4px" }} className="arrow">
                    Etapa:
                  </Styles.Text>
                  {item.valorAntigo ? (
                    <>
                      <Styles.TagAlteracao className="depois">
                        {item.valorAntigo}
                      </Styles.TagAlteracao>
                      <Styles.Text
                        style={{ margin: "0 4px" }}
                        className="arrow"
                      >
                        {"->"}
                      </Styles.Text>
                    </>
                  ) : (
                    <></>
                  )}
                  {item.valorNovo ? (
                    <Styles.TagAlteracao className="antes">
                      {item.valorNovo}
                    </Styles.TagAlteracao>
                  ) : (
                    <Styles.TagAlteracao className="depois">
                      --
                    </Styles.TagAlteracao>
                  )}
                </Styles.TagAlteracaoBody>
              </>
            ) : (
              <></>
            )}

            {item.campoAlterado === "Status Oportunidade" ? (
              <>
                <Styles.TagAlteracaoBody>
                  <Styles.Text style={{ margin: "0 4px" }} className="arrow">
                    Status:
                  </Styles.Text>
                  {item.valorAntigo ? (
                    <>
                      <Styles.TagAlteracao className="depois">
                        {item.valorAntigo}
                      </Styles.TagAlteracao>
                      <Styles.Text
                        style={{ margin: "0 4px" }}
                        className="arrow"
                      >
                        {"->"}
                      </Styles.Text>
                    </>
                  ) : (
                    <></>
                  )}

                  <Styles.TagAlteracao className="antes">
                    {item.valorNovo}
                  </Styles.TagAlteracao>
                </Styles.TagAlteracaoBody>
              </>
            ) : (
              <></>
            )}
          </>
        ))}
      </Styles.BodyTarefas>
    </>
  );
};

export default HistoricoOportunidade;
